import EventDispatcher from '../events/EventDispatcher';

/**
 * @class
 * @inheritDoc
 * @extends EventDispatcher
 * @memberOf module:layout
 * @classdesc Базовый класс для UI прелоадера
 */
class LoaderUI extends EventDispatcher {

    /**
     * @constructor
     * @param {module:layout.DOMLayout} layout
     * @param {module:media.Loader} loader
     */
    constructor(layout, loader) {
        super();

        this.layout = layout;
        this.container = layout.getLayer('preloader');
        this.loader = loader;

        this._dispatchComplete = () => {
            /**
             * @event module:layout.LoaderUI#complete
             * @type {module:events.SquireEvent}
             */
            this.emit('complete');
        }
    }

    destructor() {
        this.removeAllEventListeners();
        this.layout = null;
        this.container = null;
        this.loader = null;
    }

    removeAllEventListeners(){
        super.removeAllEventListeners();
        this.removeListeners();
    }

    removeListeners() {
        this.layout.off('fitlayout', this.fitLayout);
        this.loader.off('progress', this.showProgress);
        this.loader.off('complete', this.showComplete);
    }

    addListeners() {
        this.removeListeners();
        this.layout.on('fitlayout', this.fitLayout, this);
        this.loader.on('progress', this.handleProgress, this);
        this.loader.once('complete', this.handleComplete, this);
    }

    handleProgress() {
        let {total, complete, progress} = this.loader.progressInfo;
        let prc = Math.round(progress * 100);
        this.showProgress(prc);
    }

    handleComplete() {
        this.showProgress(100);
        this.showComplete();
    }

    dispatchComplete() {
        this.emit('complete');
    }

    showProgress() { /** implement this in ancestors */ }
    showComplete() { /** implement this in ancestors */ }
}

export default LoaderUI;